module.exports = __webpack_public_path__ + "static/img/512_new.9d3dfdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/512_new.png
// module id = 7BxL
// module chunks = 0